import { AppOutlet } from 'app-layered-layout/AppProvider'
import { useSelector } from 'react-redux'
import { selectTokenInfo, selectUserInfo } from 'redux/selector/user'

export const BareLayout = () => {
  const tokenInfo = useSelector(selectTokenInfo)
  const userInfo = useSelector(selectUserInfo)
  return <>{tokenInfo?.access_token && userInfo?.id && <AppOutlet />}</>
}
